import { products } from '@/mocks/products';
import ProductCard from '@/components/feature/ProductCard';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function Bestsellers() {
  const bestsellers = products.slice(0, 8);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-none mx-auto px-4 md:px-6">
        <ScrollReveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8 md:mb-12">
            <div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary-500">
                Loved on Repeat
              </h2>
              <p className="text-sm md:text-base text-foreground-500 mt-1 font-label">
                The pieces our community keeps coming back to
              </p>
            </div>
          </div>
        </ScrollReveal>

        {/* Scrollable row on mobile, grid on desktop */}
        <div className="flex overflow-x-auto gap-4 pb-4 -mx-4 px-4 md:grid md:grid-cols-2 lg:grid-cols-4 md:gap-5 md:overflow-x-visible md:pb-0 md:mx-0 md:px-0 snap-x snap-mandatory">
          {bestsellers.map((product, idx) => (
            <ScrollReveal
              key={product.id}
              delay={idx * 90}
              className="min-w-[260px] md:min-w-0 snap-start"
            >
              <ProductCard product={product} showCommerce={false} />
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}